export default function SupplierPanel() {

  return (
      <p>پنل تأمین کننده</p>
  );
};